import script from "./SectionThreePanels.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionThreePanels.vue?vue&type=script&setup=true&lang=js"

import "./SectionThreePanels.vue?vue&type=style&index=0&id=84874996&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84874996"]])

export default __exports__